if (!customElements.get('rm-collections-filter')) {
  customElements.define('rm-collections-filter', class RmCollectionsFilter extends HTMLElement {
    constructor() {
      super();
      
      this.input = document.getElementById('rm-collections-filter');
      this.cardsContainer = document.querySelector('.rm-dynamic-collections-wrapper');
      this.cards = this.cardsContainer.querySelectorAll('.rm-dynamic-collections-item')

      this.input.addEventListener('keyup', this.filterItems.bind(this));
    }

    filterItems() {
      const filter = this.input.value.toLowerCase();
    
      for (let i = 0; i < this.cards.length; i++) {
        const card = this.cards[i];
        const cardLink = card.getElementsByTagName("a")[0];
        const cardTextValue = (cardLink.textContent || cardLink.innerText).trim();

        if (cardTextValue.toLowerCase().indexOf(filter) > -1) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      }
    }

  });
}